import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack gap-3 mb-6" }
const _hoisted_2 = { class: "d-flex align-items-end w-100 w-lg-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_4 = { class: "d-flex align-items-end flex-wrap gap-2 w-100 w-lg-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building-add fs-2 me-2 text-white" }, null, -1)
const _hoisted_6 = { class: "w-100 w-md-250px w-lg-250px" }
const _hoisted_7 = { class: "d-block fw-bold" }
const _hoisted_8 = { class: "w-100 w-md-150px w-lg-150px" }
const _hoisted_9 = { class: "d-block fw-bold" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "image-slot" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle fs-1 text-danger" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear fs-2 p-0 cursor-pinter" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.filter.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.search) = $event)),
          class: "w-100 w-lg-350px",
          placeholder: `${_ctx.t('search')}...`,
          clearable: "",
          onKeypress: _withKeys(_ctx.getData, ["enter"]),
          onClear: _ctx.getData
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: _ctx.t('search'),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.getData
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onKeypress", "onClear"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onRegister,
          class: "w-100 w-md-auto w-lg-auto"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t('categorie')), 1),
          _createVNode(_component_el_select, {
            modelValue: _ctx.filter.category,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.category) = $event)),
            clearable: "",
            multiple: "",
            "collapse-tags": "",
            class: "me-4",
            placeholder: _ctx.t('all'),
            onChange: _ctx.getData
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.categories, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.iddetails,
                  label: item.name,
                  value: item.iddetails
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('ambit')), 1),
          _createVNode(_component_el_select, {
            modelValue: _ctx.filter.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.type) = $event)),
            "empty-values": [''],
            "value-on-clear": '',
            clearable: "",
            class: "me-4",
            placeholder: _ctx.t('all'),
            onChange: _ctx.getData
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.types, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.iddetails,
                  label: item.name,
                  value: item.iddetails
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "onChange"])
        ])
      ])
    ]),
    (_ctx.listClubs.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.listClubs,
            border: "",
            "table-layout": 'auto',
            height: _ctx.altura <= 400 ? '400px' : _ctx.altura + 'px',
            "scrollbar-always-on": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "idinstitution",
                label: "ID",
                width: "80",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('name')
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_image, {
                      shape: "square",
                      fit: "contain",
                      src: `${_ctx.REPO}/${row?.avatar}`,
                      class: "me-3 bg-transparent w-35px"
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: "Imágen no disponible",
                            placement: "left"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 2
                    }, 1032, ["src"]),
                    _createVNode(_component_router_link, {
                      to: `/${_ctx.company?.alias.toLowerCase()}/institutions/${row?.idinstitution}/repman`,
                      class: "text-dark-50 text-hover-primary cursor-pointer",
                      style: {"line-height":"1.25"}
                    }, {
                      default: _withCtx(() => [
                        (row?.abrev)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.abrev.toUpperCase()), 1))
                          : _createCommentVNode("", true),
                        _hoisted_14,
                        (row?.name)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(row.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "category_name",
                label: _ctx.t('categorie')
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.category?.name), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "type_name",
                label: "Ámbito"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.instype?.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "Afiliación" }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(`badge badge-${row.afiliate?.params}`)
                  }, _toDisplayString(row.afiliate?.name), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: _ctx.t('state'),
                width: "120",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass('badge badge-' + row.status?.params)
                  }, _toDisplayString(row.status?.name), 3)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                width: "120",
                label: _ctx.t('options'),
                fixed: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: _ctx.t('edit'),
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-pencil-square fs-2 text-hover-primary me-3 cursor-pointer",
                          onClick: ($event: any) => (_ctx.onEdit(row))
                        }, null, 8, _hoisted_17)
                      ]),
                      _: 2
                    }, 1032, ["content"]),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: _ctx.t('delete'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-trash fs-2 text-hover-danger me-3 cursor-pointer",
                          onClick: ($event: any) => (_ctx.onDelete(row))
                        }, null, 8, _hoisted_18)
                      ]),
                      _: 2
                    }, 1032, ["content"]),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: _ctx.t('setting'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/${_ctx.company?.alias.toLowerCase()}/institutions/${row?.idinstitution}/repman`
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "height"])), [
            [_directive_loading, _ctx.loader]
          ]),
          _createVNode(_component_el_pagination, {
            class: "mt-4",
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
            "page-size": _ctx.pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
            "page-sizes": [10, 100, 200, 300, 400],
            "pager-count": 4,
            size: "small",
            background: "",
            layout: "total, sizes, prev, pager, next",
            total: _ctx.totalItems,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ], 64))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón registros"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a intentar")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_AddEdit, {
      setting: _ctx.setting,
      onOnResponse: _ctx.onResponse,
      item: _ctx.rowItem
    }, null, 8, ["setting", "onOnResponse", "item"])
  ], 64))
}